import { UserAgent } from './UserAgent';

export function isBot(): boolean {
    if (typeof window === 'undefined') {
        return false;
    }

    return UserAgent.current().isBot() || '_DATADOG_SYNTHETICS_BROWSER' in window;
}
